module.exports = __webpack_public_path__ + "assets/img/legacy_icon.654d6a10.png";